var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('homer-slider'),_c('gpb-usd'),_c('advantage'),_c('footer-slider'),_c('start-trading-slider'),_c('contact-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }